import { useFeatureAccess } from "../../../access-control/hooks/useFeatureAccess";
import { useAuthContext } from "../../../auth/state/AuthContext";
import { ADMIN_PATHS, ADMIN_SIDEBAR_ITEMS } from "../../models/admin.models";
import { ADMIN_DASHBOARD_MANAGEMENT_LINKS } from "../../utils/admin-dashboard.constants";
import { canViewAdminDashboardManagementLink } from "../../utils/admin-dashboard.utils";
import { Link } from "react-router-dom";

// Reference settings and diagnostics stay within easy reach without adding more KPI tiles.
const AdminDashboardManagementLinks = () => {
  const { hasFeature } = useFeatureAccess();
  const groups = useAuthContext().state.user?.accessToken?.groups ?? [];
  const links = ADMIN_DASHBOARD_MANAGEMENT_LINKS.flatMap((link) => {
    const item = ADMIN_SIDEBAR_ITEMS.find((candidate) => candidate.id === link.id);

    return item && canViewAdminDashboardManagementLink(item, groups, hasFeature)
      ? [{ ...item, label: link.label }]
      : [];
  });

  return (
    <nav
      aria-label="Administration settings and tools"
      data-test="admin-dashboard-management-links"
      className="border-t border-black/10 pt-5 dark:border-white/10"
    >
      <h2 className="mb-3 text-sm font-semibold">Settings & tools</h2>
      <div className="flex flex-wrap gap-x-6 gap-y-3 text-xs">
        {links.map((item) => (
          <Link
            key={item.id}
            to={item.path}
            data-test={`admin-dashboard-manage-${item.id}`}
            className="rounded-sm opacity-70 hover:text-green hover:opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-green"
          >
            {item.label}
          </Link>
        ))}
        <Link
          to={ADMIN_PATHS.debugOnboarding}
          data-test="admin-dashboard-manage-onboarding"
          className="rounded-sm opacity-70 hover:text-green hover:opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-green"
        >
          Onboarding
        </Link>
        <Link
          to={ADMIN_PATHS.debugVoyagePnl}
          data-test="admin-dashboard-manage-pnl-debug"
          className="rounded-sm opacity-70 hover:text-green hover:opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-green"
        >
          PnL diagnostics
        </Link>
      </div>
    </nav>
  );
};

export default AdminDashboardManagementLinks;
